import React from "react";
import { LOGIN } from "../enums/UrlPaths";
import { useNavigate } from "react-router-dom";
import AlertPopUp from "./dialogs/AlertPopUp";
import { useTranslation } from "react-i18next";
import LogoutIcon from "@mui/icons-material/Logout";
import useUser from "../hooks/useUser";
import { useQueryClient } from "@tanstack/react-query";
import { LOGGED_IN_USER, LOGIN_KEYS, TOKENS_KEY } from "../enums/QueryKeys";

export default function Logout({ children }) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { roles, currentClinic } = useUser();

  const { t } = useTranslation();

  function callLogout() {
    queryClient.removeQueries([LOGGED_IN_USER]);
    queryClient.removeQueries([TOKENS_KEY]);
    queryClient.removeQueries([LOGIN_KEYS]);
    localStorage.clear();

    if (roles.adminOrEmployee) {
      navigate(LOGIN + "/" + currentClinic?.shortName);
    } else {
      navigate(LOGIN);
    }
  }

  function handleLogout() {
    callLogout();
  }

  return (
    <AlertPopUp
      btnMessage={t("LogOut")}
      onAgree={handleLogout}
      title={t("Warning")}
      content={t("ReallyWantLogOut")}
      btnNegativeTitle={t("Stay")}
      btnPoisitveTitle={t("LogOut")}
      fullWidth
      startIcon={<LogoutIcon />}
      color={"error"}
    />
  );
}
